import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TfSearchFiltersComponent } from './components/search-filters/search-filters.component'
import { TfSelectedFiltersComponent } from './components/selected-filters/selected-filters.component';

import { TfFiltersModule } from '@app/modules/tf-filters';

import { TfFiltersTruncate } from './pipes/filter-truncate.pipe';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { TfButtonModule } from '@app/modules/tf-buttons';
import { TfCheckboxModule } from '@app/modules/tf-checkbox';
import { TfInputFieldsModule } from '@app/modules/tf-input-fields';

@NgModule({
    declarations: [
        TfSelectedFiltersComponent,
        TfSearchFiltersComponent,
        TfFiltersTruncate
    ],
    imports: [
        CommonModule,
        NgbPopoverModule,
        TfCheckboxModule,
        TfFiltersModule,
        TfButtonModule,
        TfInputFieldsModule
    ],
    exports: [
        TfSearchFiltersComponent
    ]
})
export class TfSearchFiltersModule {
}
